<template>
	<el-config-provider :locale="locale" :size="config.size" :zIndex="config.zIndex" :button="config.button">
		<router-view></router-view>
		<DialogProvider></DialogProvider>
	</el-config-provider>
</template>

<script>
	import colorTool from '@/utils/color'
	import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
	import en from "element-plus/lib/locale/lang/en";
	import sysConfig from "@/config"
    import tool from '@/utils/tool'
	export default {
		name: 'App',
		
		data() {
			return {
				config: {
					size: "default",
					zIndex: 2000,
					button: {
						autoInsertSpace: false
					}
				},
				locales: {
						['zh-cn']:zhCn,
						en
			   },
			   language: tool.data.get("APP_LANG") || sysConfig.LANG
			}
		},

		computed: {

			locale(){
				return this.locales[this.language]
			},
		},
		created() {
			//设置主题颜色
			const app_color = this.$CONFIG.COLOR || this.$TOOL.data.get('APP_COLOR')
			if(app_color){
				document.documentElement.style.setProperty('--el-color-primary', app_color);
				for (let i = 1; i <= 9; i++) {
					document.documentElement.style.setProperty(`--el-color-primary-light-${i}`, colorTool.lighten(app_color,i/10));
				}
				for (let i = 1; i <= 9; i++) {
					document.documentElement.style.setProperty(`--el-color-primary-dark-${i}`, colorTool.darken(app_color,i/10));
				}
			}
		}
	}
</script>

<style lang="scss">
	@import '@/style/style.scss';
</style>
